module.exports = __webpack_public_path__ + "static/media/SK.853919fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/SK.svg
// module id = 2260
// module chunks = 7